import axios from 'axios'
import BlogDetail from 'apps/BlogDetail'
import { getCommonStaticProps } from 'commonPage'
import { safePromise } from 'utils/universal/safePromise'
import commonMessages from 'locales/es/common'
import commonEnMessages from 'locales/en/common'
import blogMessages from 'locales/es/blog'
import blogEnMessages from 'locales/en/blog'

export default BlogDetail

export async function getStaticPaths({ locales }) {
  const url = `${process.env.NEXT_PUBLIC_API_ROOT}/posts/`
  const { result } = await safePromise(axios(url))
  // Get the paths we want to pre-render based on posts
  // const paths = result?.data?.map((post) =>
  //   locales.map((locale) => ({
  //     params: { slug: post?.slug },
  //     locale:
  // })))

  const paths = result?.data
    .map((post) => locales.map((locale) => ({
      params: { slug: post?.slug },
      locale, // locale should not be inside `params`
    })))
    .flat()

  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return { paths, fallback: false }
}

export async function getStaticProps({ params, locale }) {
  const commonStaticProps = await getCommonStaticProps()
  const messages = locale === 'es'
    ? { ...commonMessages, ...blogMessages }
    : { ...commonEnMessages, ...blogEnMessages }
  const blogSlug = params?.slug
  const { result } = await safePromise(
    axios(
      `${process.env.NEXT_PUBLIC_API_ROOT}/posts/${blogSlug}/`,
    ),
  )

  const post = result?.data

  if (post === null) {
    return {
      notFound: true,
    }
  }

  const relatedUrl = `${process.env.NEXT_PUBLIC_API_ROOT}/posts/related_posts/${post?.state}/post/${post?.id}/`
  const { result: relatedResult } = await safePromise(axios(relatedUrl))

  // Get the paths we want to pre-render based on posts
  return {
    props: {
      ...commonStaticProps,
      headerProps: {
        activeIndex: 3,
        breadcrumbs: [],
      },
      messages,
      post: result?.data ?? {},
      relatedPosts: relatedResult?.data ?? [],
    },
  }
}
